import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../../authConfig';
import './Login.css';
import axios from 'axios';
import Cookies from 'universal-cookie';

const AtLoginButton = () => {
	const { instance } = useMsal();
	const navigate = useNavigate();
	const [failedAuth, setFailedAuth] = useState(false);
	const cookies = new Cookies();

	useEffect(() => {
		instance
			.handleRedirectPromise()
			.then((msalResponse) => {
				const account = msalResponse?.account;

				if (!account) return;

				const {
					name,
					username,
					homeAccountId,
					environment,
					tenantId,
					localAccountId,
				} = account;

				const payload = {
					homeAccountId,
					environment,
					tenantId,
					username,
					localAccountId,
					name: name ?? '',
					idTokenClaims: msalResponse?.idTokenClaims ?? {},
				};

				axios
					.post('/login', payload)
					.then((response) => {
						cookies.set('jwt_token', response.data.access_token ?? '', {
							path: '/',
						});
						cookies.set('name', name ?? '', { path: '/' });
						cookies.set('email', username ?? '', { path: '/' });

						navigate('/dashboard', { replace: true });
					})
					.catch((err) => {
						console.error('Auth-admin error', err);
						setFailedAuth(true);
						setTimeout(() => setFailedAuth(false), 3000);
					});
			})
			.catch((err) => {
				console.error('Redirect handling error', err);
				setFailedAuth(true);
				setTimeout(() => setFailedAuth(false), 3000);
			});
	}, [instance, navigate]);

	const loginHandler = () => {
		instance.loginRedirect(loginRequest);
	};

	if (failedAuth) {
		return <p className='notAuthenticatedUser'>User not authenticated</p>;
	}

	return (
		<button
			type='button'
			onClick={loginHandler}
			className='w-full bg-primary text-white font-semibold p-4 py-3 rounded-md max-w-[340px] hover:bg-primary/80 transition-all duration-300'
		>
			Sign in with Microsoft
		</button>
	);
};

export default AtLoginButton;
